// Master environment config is the same as release except for the app-flow channel
export const environment = {
  production: true,
  environmentName: 'release',
  apiKey: 'qGkTowXWf86SUTbXAEjfE4uRYxI6lVYh9FolGJjw', // staging AND prod
  baseUrl: 'release.containers.staging-mable.com.au',
  basePath: '/app',
  apiHeaders: {
    'X-Bypass-Authentication': 'a9394bd2bba377a042da123e9f140944',
  },
  isLocalHost: true,
  optimizelySDKKey: 'MvyhySX2FaxSNAZuR5Bae',
  sendBirdAppId: '76F4DE18-32EA-4D0C-A3D3-80C6A559C003',
  spreedlyKey: '2NFMYT0MbMBQmigjzLdBrKT6xqv',
  recaptchaKey: '6Lf8Y1oUAAAAABB3IH1BBmraHUsrAOIe2jItSlp7',
  requireRecaptchaForSignup: false,
  channel: 'master',
  servicePath: '/service',
  serviceUrl: () => `https://${environment.baseUrl}${environment.servicePath}`,
  apiUrl: () => `https://${environment.baseUrl}${environment.basePath}`,
  actionCableUrl: () => `wss://${environment.baseUrl}${environment.basePath}`,
  webAppUrl: () => `https://${environment.baseUrl}`, // Used for constructing web app links
  deeplinkHost: 'release.link.ionicapp.staging-mable.com.au',
  clientAppDeeplink: 'release.link.clientapp.staging-mable.com.au',
  segmentConfig: {
    writeKey: 'Sxd2uPOVLjKS0RB5HyIqoRcqdIi8BIdj',
    cdnDomain: 'analytics-cdn.release.containers.staging-mable.com.au',
    apiDomain: 'analytics-api.release.containers.staging-mable.com.au',
    cdnUrl: () => `https://${environment.segmentConfig.cdnDomain}`,
    apiHost: () => `${environment.segmentConfig.apiDomain}/v1`,
  },
  datadogConfig: {
    common: {
      clientToken: 'pub7b0860df2feaf2827355f439d74836ad', // The Datadog client token.
      site: 'datadoghq.com', // The Datadog site parameter of organization.
      service: 'mable-mobile-app', // The service name for application.
    },
    browserLogs: {
      forwardConsoleLogs: 'all', // Forward logs from console.* to Datadog.
      telemetrySampleRate: 100, // Telemetry data sample rate about SDK execution sent to Datadog.
    },
    rum: {
      applicationId: '25c15439-34fd-4e94-ad5c-24916e736576',
      defaultPrivacyLevel: 'mask', // The default privacy level applied to data in the user session replays.
    },
  },
  identityVerificationServiceConfig: {
    useLocal: false,
    port: 4000,
  },
  fusionAuthConfig: {
    url: 'https://auth.staging-mable.com.au',
    tenantId: 'cb950c42-2fde-40c6-b62e-0e3fac32b094',
    clientId: 'f556606a-5f35-42c3-bd4c-09486fa923af',
    oAuthCallbackUrl: 'mable://oauth-callback',
    logoutCallbackUrl: 'mable://logout-callback',
  },
};
